import api from "../api";
import {subscribeToChannel, unsubscribeToChannel} from "../services/pusher";
import {EntityCollection} from "../server/EntityCollection.class";

const state = () => ({
  records: new EntityCollection(),
  loadingMoreRecords: true,
});

const getters = {
  records(state, getters, rootState, rootGetters) {
    return state.records;
  },
};

const mutations = {
  setup(state) {
    state.records.clearItems();
  },
  teardown(state,) {
    state.records.clearItems();
  },
  addRecords(state, recordsEntity) {
    state.records.merge(recordsEntity);
  }
};

const actions = {
  setup({commit, state, rootState, getters, dispatch, rootGetters}) {
    commit('teardown');
    commit('followUpState/teardown', null, {root: true});
    subscribeToChannel("recordsInAutomatedFollowUp", rootState.market.market.id);
    dispatch('loadMoreRecords');
  },

  tearDown({commit, state, rootState, getters, rootCommit}) {
    unsubscribeToChannel("recordsInAutomatedFollowUp", rootState.market.market.id);
    commit('teardown');
  },
  loadMoreRecords({commit, state, rootState, rootGetters, dispatch}) {
    this.loadingMoreRecords = true;

    commit('followUpState/incrementLastPage', null, { root:true });
    let query = rootGetters["followUpState/queryString"];

    return api.clientStore.initRecordsInAutomatedFollowUp(rootState.market.market.id, query).then(response => {
      commit('addRecords', response.data.records)

      // Note this is also in recordsInManualFollowUp.store.js
      if (rootGetters["followUpState/pageSize"] > response.data.records.order.length) {
        commit('followUpState/hasMoreRecordsToLoad', false, { root:true });
      }
    }).finally(() => {
      this.loadingMoreRecords = false;
    });
  },
};

const RecordsInAutomatedFollowUpStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default RecordsInAutomatedFollowUpStore;
